module.exports = __webpack_public_path__ + "img/stoneholder-2.2d0dab9.webp";